/**
 * Reusable button style utilities
 * These styles are consistent with the design system used across the app
 */

export const BUTTON_STYLES = {
  // Primary action button (solid lime green)
  primary: 'bg-[#C0FD72] text-black hover:bg-[#b0ef62]',

  // Secondary button (dark with border)
  secondary: 'border border-[#2a3441] bg-[#1a2030] text-white hover:bg-[#22293a]',

  // Outline button (transparent with border)
  outline: 'border border-[rgba(54,65,83,0.45)] bg-transparent text-white hover:bg-[#1a2030]',
}
